const common = {
  // Nav
  nav_materials: 'Materials',
  nav_account: 'Account',
  nav_agent_portal: 'Agent Portal',
  nav_sign_out: 'Sign Out',
  nav_account_settings: 'Account Settings',
  nav_download_history: 'Download History',
  nav_help: 'Help & Support',
  nav_expires_in: 'Expires in',
  nav_days: 'd',
  nav_account_type: 'Account Type',
  nav_region: 'Region',
  nav_valid_until: 'Valid Until',
  nav_search_placeholder: 'Search materials, categories, tags...',

  // Login
  login_welcome: 'Welcome back',
  login_subtitle: 'Sign in to your agent account',
  login_tab_signin: 'Sign In',
  login_tab_apply: 'Apply for Account',
  login_email: 'Email Address',
  login_password: 'Password',
  login_forgot: 'Forgot password?',
  login_remember: 'Remember me for 30 days',
  login_btn: 'Sign In to Portal',
  login_signing_in: 'Signing in...',
  login_need_help: 'Need help?',
  login_contact: 'Contact support',
  login_hero_label: 'Agent Portal',
  login_hero_title: 'Access Premium Medical Device Resources',
  login_hero_sub: 'Your exclusive gateway to Sinovision product materials, technical documentation, and sales resources.',
  login_secure: 'Secure & Watermarked',
  login_secure_desc: 'All documents are protected with dynamic watermarks. Downloads are permission-controlled per account level.',

  // Register
  reg_apply: 'Apply for access',
  reg_subtitle: 'Register as an authorized distributor',
  reg_email: 'Business Email',
  reg_password: 'Password',
  reg_company: 'Company Name',
  reg_region: 'Region',
  reg_region_placeholder: 'Select your region',
  reg_btn: 'Submit Application',
  reg_submitting: 'Submitting...',
  reg_pending_title: 'Application Submitted',
  reg_pending_badge: 'Pending Agents Approval',
  reg_pending_desc: "Your application is under review. You'll receive an email notification once approved, typically within 1-2 business days.",
  reg_back_signin: 'Back to Sign In',

  // Library
  lib_showing: 'Showing',
  lib_materials: 'materials',
  lib_no_results: 'No materials found',
  lib_no_results_sub: 'Try adjusting your search or filters',
  lib_clear_filters: 'Clear filters',
  lib_preview: 'Preview',
  lib_download: 'Download',
  lib_no_permission: 'No permission',
  lib_popular: 'Popular',
  lib_categories: 'Categories',
  lib_sort_by: 'Sort By',
  lib_sort_latest: 'Latest Upload',
  lib_sort_popular: 'Most Popular',
  lib_sort_az: 'A → Z',
  lib_file_type: 'File Type',
  lib_all_types: 'All Types',
  lib_pdf: 'PDF Documents',
  lib_ppt: 'Presentations',
  lib_all_materials: 'All Materials',
  lib_collapse_models: 'Collapse',
  lib_expand_models: 'Expand',

  // Primary categories
  primary_products: 'Product Line',
  primary_training: 'Training & Learning',
  primary_software: 'Software & Systems',

  // Preview Modal
  preview_page: 'Page',
  preview_of: '/',
  preview_preview_only: 'Preview only — Download requires permission',
  lib_view_only: 'View Only',
  lib_watermark_protected: 'Watermark Protected',

  // Admin Nav
  admin_nav_dashboard: 'Dashboard',
  admin_nav_agents: 'Agent Management',
  admin_nav_materials: 'Materials',
  admin_nav_permissions: 'Permissions',
  admin_nav_analytics: 'Analytics',
  admin_nav_watermark: 'Watermark',
  admin_back_portal: 'Back to Portal',

  // Account
  acc_active: 'Active Account',
  acc_expires_in: 'Account expires in',
  acc_expires_days: 'days',
  acc_expires_contact: 'Please contact your Sinovision representative to renew.',
  acc_renew: 'Renew Now',
  acc_overview: 'Overview',
  acc_history: 'Download History',
  acc_permissions: 'Access Permissions',
  acc_granted: 'Granted',
  acc_restricted: 'Restricted',
  acc_quick_actions: 'Quick Actions',
  acc_browse: 'Browse Material Library',
  acc_contact: 'Contact Support',
  acc_change_pw: 'Change Password',
  acc_upgrade_title: 'Need More Access?',
  acc_upgrade_sub: 'Upgrade Your Permissions',
  acc_upgrade_desc: 'Contact your Sinovision regional manager to unlock additional download permissions.',
  acc_upgrade_btn: 'Request Upgrade',
  acc_recent_dl: 'Recent Downloads',
  acc_redownload: 'Re-download',
  acc_account_type: 'Account Type',
  acc_region: 'Region',
  acc_member_since: 'Member Since',
  acc_valid_until: 'Valid Until',
};

export default common;
